import { render, staticRenderFns } from "./SyncConfigDialog.vue?vue&type=template&id=ae28d540&scoped=true&"
import script from "./SyncConfigDialog.vue?vue&type=script&lang=js&"
export * from "./SyncConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae28d540",
  null
  
)

export default component.exports